"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var lodash_1 = __importDefault(require("lodash"));
var BasicIcon_1 = __importDefault(require("../../../common/BasicIcon"));
var PhoneInputRow_1 = __importDefault(require("./PhoneInputRow"));
var strings_1 = require("../../../../helpers/strings");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PhoneInputList = function (_a) {
    var contacts = _a.contacts, onAddEmpty = _a.onAddEmpty, onChange = _a.onChange, onRemove = _a.onRemove, _b = _a.validation_errors, validation_errors = _b === void 0 ? [] : _b;
    var t = react_i18next_1.useTranslation('common').t;
    var addEmpty = function (e) {
        e.preventDefault();
        if (hasEmpty() || validation_errors.length) {
            return;
        }
        onAddEmpty(__spreadArray(__spreadArray([], contacts), [
            {
                id: strings_1.generateUUID(),
                phone: '',
                code: 'am',
                messengers: [],
            },
        ]));
    };
    var remove = function (e, id) {
        e.preventDefault();
        onRemove(contacts.filter(function (contact) { return contact.id !== id; }));
    };
    var hasEmpty = function () {
        return lodash_1.default.some(contacts, function (c) {
            return !c.phone;
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        contacts.map(function (contact, index) {
            return (react_1.default.createElement(PhoneInputRow_1.default, { key: index, contact: contact, index: index, onChange: onChange, remove: remove, error: validation_errors[index] }));
        }),
        react_1.default.createElement("a", { href: "#", className: styles_module_scss_1.default.add_phone, onClick: addEmpty },
            react_1.default.createElement(BasicIcon_1.default, { iconClass: "icon-add", iconLabel: "+ " + t('Account.Settings.Add') }))));
};
exports.default = PhoneInputList;
